import realMixpanel from 'mixpanel-browser';
import config from '../config';
import { isReactNativeApp } from './mobileRNApp';

delete window.mixpanel; // remove from global scope, force importing from here

/** @type {    
    alias: Function,
    identify: Function,
    register: Function,
    reset: Function,
    people: {
      set: Function,
    },
    track: Function,
} * */
let mixpanel;
if (config.MIXPANEL_KEY) {
  mixpanel = realMixpanel;
  mixpanel.init(config.MIXPANEL_KEY);
  mixpanel.register({ 'mySunrun Git Hash': __GIT_REVISION__ }); //eslint-disable-line
} else {
  mixpanel = {
    alias: () => null,
    identify: () => null,
    register: () => null,
    reset: () => null,
    people: {
      set: () => null,
    },
    track: () => null,
  };
}

const aliasUser = user => {
  // alias should only be called once, right after login, to map a user’s
  // anonymous events from before a signup event with the post-signup activity
  // identify can be called other times to find a user by email
  mixpanel.alias(user.emailAddress);
  return mixpanel.track('Logged In');
};

const trackUser = user => {
  try {
    // null checking, to make sure data is there
    const initialAccount = user.opportunities?.length > 0 && user.opportunities.filter(o => o.opptyId === user.opptyId)[0];
    const initialContract = initialAccount.contract ? initialAccount.contract : {};
    const initialMasterIds = user.masterContractInfo && user.masterContractInfo.length > 0 ? user.masterContractInfo[0] : {};
    const userName = `${user.firstName} ${user.lastName}`;

    const { address, city, state, zip, country } = user;

    // eslint-disable-next-line camelcase
    const salesRepEmail = initialAccount.salesRepInfo?.email_address;

    const person = {
      Address: `${address} ${city}, ${state} ${zip} ${country}`,
      'Agreement type': initialContract.agreementType,
      Battery: initialContract.brightBox,
      'Billing Method': initialAccount.billingMethod,
      'Billing System': initialContract.billingSystem,
      'Current Owner': initialAccount.isCurrentOwner,
      'Customer Name': userName,
      'Customer Type': initialAccount.customerType,
      Email: user.email,
      'Install Partner': initialContract.installPartnerName,
      'Is Multi-Family': initialAccount && initialAccount.isMultiFamilyHome,
      'Is Related Contact': initialAccount && initialAccount.isRelatedContact,
      'Master Id': initialMasterIds.masterId,
      Mobile: user.phoneNumber ?? user.mobilePhoneNumber,
      'Oppty ID': initialAccount.opptyId,
      'PTO Date': initialContract.ptoDate,
      'Project Phase': initialContract.status,
      'Proposal ID': initialContract.proposalId,
      'Prospect ID': initialAccount.prospectId,
      'Purchased Thru': initialContract.purchasedThru,
      'Sales Rep email': salesRepEmail,
      'Service Contract Number': initialAccount.serviceContractId,
      'System Count': user.opportunities?.length,
      'Utility Company': initialContract.utilityCompany,
      ReactNativeApp: isReactNativeApp(),
    };
    mixpanel.register(person);
    mixpanel.people.set(person);
    return mixpanel.identify(user.email);
  } catch (e) {
    return null;
  }
};

export default mixpanel;
export { aliasUser, trackUser };
